import type { NavEntry } from '@/pages/home/types';

interface EntryModalProps {
  entry: NavEntry;
  categoryName: string;
  copied: boolean;
  onCopy: (entry: NavEntry) => void;
  onClose: () => void;
}

export default function EntryModal({ entry, categoryName, copied, onCopy, onClose }: EntryModalProps) {
  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-foreground-950/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={`${entry.name} 入口详情`}
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg rounded-lg border border-background-200 bg-background-50 p-5 md:p-7"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700 md:h-12 md:w-12">
              <i className="ri-links-line" aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{entry.name}</h3>
              <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{categoryName}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭弹窗"
            className="flex h-9 w-9 items-center justify-center rounded-md text-xl text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-950"
          >
            <i className="ri-close-line" aria-hidden="true"></i>
          </button>
        </div>

        <p className="mt-5 text-sm leading-relaxed text-foreground-700">{entry.desc}</p>

        <div className="mt-4 flex flex-wrap gap-2">
          {entry.tags.map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-5 flex items-center justify-between rounded-md border border-background-200 bg-background-100 px-4 py-3">
          <div className="min-w-0">
            <p className="text-xs text-foreground-500">直达地址</p>
            <p className="mt-0.5 truncate text-sm text-foreground-800">{entry.addr}</p>
          </div>
          <button
            type="button"
            onClick={() => onCopy(entry)}
            className={`ml-3 inline-flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
              copied ? 'bg-secondary-500 text-background-50' : 'bg-primary-500 text-background-50 hover:bg-primary-600'
            }`}
          >
            <i className={copied ? 'ri-check-line' : 'ri-file-copy-line'} aria-hidden="true"></i>
            {copied ? '已复制' : '复制地址'}
          </button>
        </div>

        <p className="mt-4 flex items-start gap-2 text-xs leading-relaxed text-foreground-500">
          <i className="ri-information-line mt-0.5 text-sm text-accent-600" aria-hidden="true"></i>
          入口地址由本站整理收录，如遇失效可在页面底部反馈表提交纠错，我们会尽快补充最新地址。
        </p>
      </div>
    </div>
  );
}